import { useEffect, useState } from "react";
import EntityEditor from "../components/EntityEditor";
import { adminApi } from "../api";

const FIELDS = [
  { key: "name", label: "Nome", required: true },
  { key: "slug", label: "Slug (identificativo url)", required: true, placeholder: "es. glam-hotel" },
  {
    key: "stars",
    label: "Stelle",
    type: "select",
    options: [
      { value: 3, label: "3 stelle" },
      { value: 4, label: "4 stelle" },
      { value: 5, label: "5 stelle" },
    ],
  },
  { key: "rooms", label: "Camere", type: "number" },
  { key: "area", label: "Zona", required: true, placeholder: "es. Stazione Centrale" },
  { key: "tagline", label: "Tagline (frase breve)" },
  {
    key: "description",
    label: "Descrizione",
    textarea: true,
    rows: 5,
  },
  { key: "image", label: "Immagine di copertina", type: "image" },
  { key: "logo", label: "Logo hotel (PNG/SVG trasparente)", type: "image" },
  {
    key: "gallery",
    label: "Galleria (foto aggiuntive)",
    type: "gallery",
  },
  { key: "order", label: "Ordine di visualizzazione", type: "number" },
  {
    key: "_map_divider",
    type: "divider",
    label: "Posizione sulla mappa · Rigenerazione",
  },
  {
    key: "lat",
    label: "Latitudine (es. 45.4642 · vuoto = default seed)",
    type: "number",
    step: "any",
    nullable: true,
  },
  {
    key: "lng",
    label: "Longitudine (es. 9.1899 · vuoto = default seed)",
    type: "number",
    step: "any",
    nullable: true,
  },
  { key: "published", label: "Pubblicato sul sito", type: "checkbox" },

  // === Area Investitori (visibile solo nell'area riservata) ===
  {
    key: "_investor_divider",
    type: "divider",
    label: "Area Investitori (visibile solo dopo login)",
  },
  {
    key: "investor_opening",
    label: "Apertura / ristrutturazione",
    placeholder: "Es. Aprile 2015 — ristrutturazione 2021-2022",
  },
  {
    key: "investor_summary",
    label: "Descrizione (categoria, camere, breve introduzione)",
    textarea: true,
    rows: 3,
    placeholder: "Hotel 4 stelle (307 camere) Aperto da…",
  },
  {
    key: "position_bullets",
    label: "Posizione — un bullet per riga",
    textarea: true,
    rows: 3,
    list: true,
    placeholder: "Zona – Periferia Nord Milano\n140 mt dalla Stazione FS\n1 Km da Comasina",
  },
  {
    key: "services_bullets",
    label: "Servizi — un bullet per riga",
    textarea: true,
    rows: 3,
    list: true,
    placeholder: "n. 1 Bar\nn. 1 Ristorante\nn. 4 Sale Riunioni\nParcheggio privato",
  },
  {
    key: "map_embed_url",
    label: "Google Maps · URL embed (iframe src)",
    placeholder: "https://www.google.com/maps/embed?pb=…",
  },
  {
    key: "investor_image",
    label: "Tabella performance (screenshot Excel/BDO)",
    type: "image",
  },
  {
    key: "investor_photo",
    label: "Foto principale dell'hotel (area investitori)",
    type: "image",
  },
];

const INITIAL = {
  slug: "",
  name: "",
  stars: 4,
  rooms: 0,
  area: "",
  tagline: "",
  description: "",
  image: "",
  logo: "",
  gallery: [],
  order: 999,
  published: true,
  lat: null,
  lng: null,
  investor_opening: "",
  investor_summary: "",
  position_bullets: [],
  services_bullets: [],
  map_embed_url: "",
  investor_image: "",
  investor_photo: "",
};

export default function AdminHotels() {
  const [items, setItems] = useState([]);

  const load = () =>
    adminApi.get("/admin/hotels").then((r) => setItems(r.data));

  useEffect(() => {
    load();
  }, []);

  return (
    <EntityEditor
      title="Hotel"
      subtitle="Gestisci il portafoglio delle strutture operative."
      endpoint="/admin/hotels"
      fields={FIELDS}
      items={items}
      initial={INITIAL}
      onReload={load}
      renderRow={(item) => (
        <div>
          <div className="font-display text-lg">{item.name}</div>
          <div className="mt-1 text-xs text-white/50 font-mono uppercase tracking-[0.15em]">
            {"★".repeat(item.stars)} · {item.area} · {item.rooms} camere
            {item.published === false && (
              <span className="ml-3 text-red-400">BOZZA</span>
            )}
          </div>
        </div>
      )}
    />
  );
}
